import React, { createContext, ReactNode, useContext, useState } from "react";

interface DialogContextType {
  open: boolean;
  title: string;
  content: ReactNode;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
  onConfirm?: () => void;
  openDialog: (options: OpenDialogOptions) => void;
  closeDialog: () => void;
}

interface OpenDialogOptions {
  title: string;
  content: ReactNode;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
  onConfirm?: () => void;
}

const DialogContext = createContext<DialogContextType | undefined>(undefined);

export const DialogProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState<ReactNode>(null);
  const [confirmText, setConfirmText] = useState<string | undefined>(
    "Confirmar"
  );
  const [cancelText, setCancelText] = useState<string | undefined>("Cancelar");
  const [loading, setLoading] = useState<boolean | undefined>(false);
  const [onConfirm, setOnConfirm] = useState<(() => void) | undefined>(
    undefined
  );

  function openDialog(options: OpenDialogOptions) {
    setTitle(options.title);
    setContent(options.content);
    setConfirmText(options.confirmText || "Confirmar");
    setCancelText(options.cancelText || "Cancelar");
    setLoading(options.loading || false);
    setOnConfirm(() => options.onConfirm);
    setOpen(true);
  }

  function closeDialog() {
    setOpen(false);
    setLoading(false);
  }

  const value: DialogContextType = {
    open,
    title,
    content,
    confirmText,
    cancelText,
    loading,
    onConfirm,
    openDialog,
    closeDialog,
  };

  return (
    <DialogContext.Provider value={value}>{children}</DialogContext.Provider>
  );
};

export function useDialog() {
  return useContext(DialogContext);
}
